import type { PageProps } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import RoleGuard from '@components/Guards/RoleGuard';

import { RoleName } from '@constants/role_name';

import AdminManagement from '@views/Admin/Management';
import { MonitoringDetail } from '@views/EhrSync';

const messages = defineMessages({
  title: {
    id: 'admin.integrations.title',
    defaultMessage: 'Integrations',
  },
});

export default function IntegrationDetailPage({ params }: PageProps) {
  const { formatMessage } = useIntl();
  const connectionId = params.integration_id;

  // Staff-only during the internal rollout (see integrations/index.tsx).
  return (
    <RoleGuard
      roles={[RoleName.Admin, RoleName.Curator, RoleName.CuratorAdmin]}
    >
      <AdminManagement.Layout title={formatMessage(messages.title)}>
        <MonitoringDetail connectionId={connectionId} />
      </AdminManagement.Layout>
    </RoleGuard>
  );
}
